import { useState } from "react"

import background from "../../assets/images/bg5.png"
import FreeTrialForm from "../../features/freetrial/FreeTrialForm"

const Hero = () => {

    const [isFreeTrialModalOpen, setFreeTrialModalOpen] = useState(false)

    return (
        <section className="section hero has-bg-image" aria-label="home" style={{backgroundImage: `url(${background})`}}>
            <div className="container">
                <div className="hero-content">
                    <h1 className="h1 hero-title">
                        Simplify Your Work
                    </h1>

                    <p className="hero-text">
                        Advisors Reserve is purpose-built for financial advisors—helping you manage relationships with ease, 
                        fill forms at the click of a button, and maintain full control of your data, which is always yours to 
                        access and extract at any time.
                    </p>

                    <div className="btn-wrapper">
                        <a className="btn btn-primary" onClick={() => setFreeTrialModalOpen(true)}>Start Your Free Trial</a>
                        <a href="#footer" className="btn btn-outline">Watch Demo</a>
                    </div>
                </div>
            </div>
            {isFreeTrialModalOpen && <FreeTrialForm isModalOpen={isFreeTrialModalOpen} onClose={() => setFreeTrialModalOpen(false)} />}
        </section>
    )
}

export default Hero